import React, { useEffect, useState } from 'react';
import Slider from "react-slick";
import Arrow from '../Arrow';
import Card from '../Card';
import { SWAPCARD_API_KEY, EVENT_ID, SPEAKERS_GROUP_ID } from '../../consts';

const Speakers = () => {
  const [speakers, setSpeakers] = useState([]);

  const speakerSettings = {
    dots: false,
    infinite: false,
    className: "slider variable-width",
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    nextArrow: <Arrow className="slick-arrow-style" />,
    prevArrow: <Arrow className="slick-arrow-style" />
  };

  const operationsDoc = `
    query eventPerson($eventId: ID!, $filters: [EventPersonFilter!]) {
      eventPerson(eventId: $eventId, filters: $filters, sort: {field: LAST_NAME}) {
        nodes {
          id
          clientIds
          email
          firstName
          lastName
          jobTitle
          organization
          photoUrl
          socialNetworks {
            profile
            type
          }
        }
      }
    }
  `;

  useEffect(() => {
    async function fetchGraphQL(operationsDoc, operationName, variables) {
      try {
        const result = await fetch(
          "https://developer.swapcard.com/event-admin/graphql",
          {
            method: "POST",
            headers: {
              "Authorization": SWAPCARD_API_KEY,
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              query: operationsDoc,
              variables: variables,
              operationName: operationName
            })
          }
        );
        setSpeakers((await result.json())?.data?.eventPerson?.nodes);
      } catch(e) {
        console.log('error: ', e);
      }
      
    }

    const variables = {
      "eventId": EVENT_ID,
      filters: {shouldBeInGroups: SPEAKERS_GROUP_ID}
    };

    fetchGraphQL(operationsDoc, 'eventPerson', variables);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div className="speakers-row">
    <Slider {...speakerSettings}>
      {
        speakers && speakers.map(person => (
          <div className="card-wrapper" key={person.id}>
            <Card person={person} />
          </div>
        ))
      }
    </Slider>
  </div>
};

export default Speakers;
